function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    style: {
      "textIndent": 0,
      "textAlign": "start",
      "lineHeight": "normal",
      "textTransform": "none",
      "blockProgression": "tb",
      "InkscapeFontSpecification": "Bitstream Vera Sans"
    },
    d: "M 12.96875 4.28125 L 11.53125 5.71875 L 21.8125 16 L 11.53125 26.28125 L 12.96875 27.71875 L 23.96875 16.71875 L 24.65625 16 L 23.96875 15.28125 L 12.96875 4.28125 z",
    color: "#000",
    overflow: "visible",
    fontFamily: "Bitstream Vera Sans"
  }));
};

export default __webpack_public_path__ + "static/media/forward.d39bca2b.svg";
export { SvgComponent as ReactComponent };